import React, { useState, useEffect } from 'react';
import {
  Card, CardBody, Row, Col,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormFeedback, Input, Label, Button
} from "reactstrap";
import { useFormik } from 'formik';
import * as Yup from "yup";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getBilling, getCompanyDetails, updateCompany } from '../../../slices/auth/settings/thunk';
import { createSelector } from 'reselect';
import UploadLogo from '../../../Components/Common/UploadLogo';
import checkPermission from '../../../Components/Hooks/PermissionHook';
import ErrorAlert from '../../../Components/Common/ErrorAlert';
import { getBillingSuccess, resetCompanyErr } from '../../../slices/auth/settings/reducer';
import { toggleCompanyModal } from '../../../slices/modals/reducer';
import CompanyEditBtn from './CompanyEditBtn';

/**
 * Component representing a modal for updating company information.
 * This modal includes a form for editing and updating the company details.
 * @component
 */
function CompanyInfo() {
  const selectState = createSelector(state => state, state => ({
    companyInfo: state.MenuData.client,
  }));
  const { companyInfo } = useSelector(selectState);  

  function checkWebsiteLink() {
    if (companyInfo?.webSite.includes('http')) {
      return companyInfo?.webSite;
    } else if (!companyInfo?.webSite.includes('http')) {
      return 'https://' + companyInfo?.webSite;
    } else {
      return ''
    }
  }
  return (
    <React.Fragment>
      <Card className="pb-4">
        <CardBody>
          <div className="d-flex align-items-center mb-0">
            <div className="flex-grow-1">
            </div>
            <div className="flex-shrink-0">
              <CompanyEditBtn />
            </div>
          </div>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <span className="logo-lg">
              <img src={(companyInfo?.logo)} draggable="false" height="36" alt="" />
            </span>
            <h5 className="fs-16 mb-1 mt-4">{(companyInfo?.clientName || "")}</h5>
            <p className="text-muted mb-4">{(companyInfo?.contactPerson || "")}</p>
            <div className="d-flex gap-2">
              <Link
                to={checkWebsiteLink()}
                target='_blank'
                className="badge py-2 bg-success-subtle text-primary fs-15 fw-normal"
              >
                <i className="ri-global-line align-bottom"></i>
              </Link>
              <Link
                to={"mailto: " + (companyInfo?.contactEmail || "#")}
                className="badge py-2 bg-danger text-white fs-15 fw-normal"
              >
                <i className="ri-mail-line align-bottom"></i>
              </Link>
            </div>
          </div>
          <div className="d-flex flex-column mt-4">
            <p className="text-muted">INFORMATION</p>
            <p className="text-muted pe-5 mb-0">{(companyInfo?.information || '')}</p>
          </div>
          <div className="d-flex flex-column gap-3 mt-4">
            <Row>
              <Col xxl={5} sm={5} xs={6}>Industry Type</Col>
              <Col xxl={7} sm={7} xs={6}>{(companyInfo?.industryType || "")}</Col>
            </Row>
            <Row>
              <Col xxl={5} sm={5} xs={6}>Location</Col>
              <Col xxl={7} sm={7} xs={6}>{(companyInfo?.country || "")}</Col>
            </Row>
            <Row>
              <Col xxl={5} sm={5} xs={6}>Website</Col>
              <Col xxl={7} sm={7} xs={6}>
                <a href={checkWebsiteLink()} target='blank' className="text-decoration-underline">{(companyInfo?.webSite || "")}</a>
              </Col>
            </Row>
            <Row>
              <Col xxl={5} sm={5} xs={6}>Contact Email</Col>
              <Col xxl={7} sm={7} xs={6}>{(companyInfo?.contactEmail || "")}</Col>
            </Row>
            <Row>
              <Col xxl={5} sm={5} xs={6}>Since</Col>
              <Col xxl={7} sm={7} xs={6}>{(companyInfo?.since || '')}</Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default CompanyInfo
